<template>
    <b-form-group class="input-padding">
        <template #label>
            <span>{{tr(title)}}</span>
        </template>
        <b-row>
            <b-col cols="4" class="pt-3">
                <b-form-group label-cols="3">
                    <template #label>
                        <span>←</span>
                    </template>
                    <b-input v-model="currentPadding.left"/>
                    <span class="unit">px</span>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group label-cols="3">
                    <template #label>
                        <span>↑</span>
                    </template>
                    <b-input v-model="currentPadding.top"/>
                    <span class="unit">px</span>
                </b-form-group>
                <b-form-group label-cols="3">
                    <template #label>
                        <span>↓</span>
                    </template>
                    <b-input v-model="currentPadding.bottom"/>
                    <span class="unit">px</span>
                </b-form-group>
            </b-col>
            <b-col cols="4" class="pt-3">
                <b-form-group label-cols="3">
                    <template #label>
                        <span>→</span>
                    </template>
                    <b-input v-model="currentPadding.right"/>
                    <span class="unit">px</span>
                </b-form-group>
            </b-col>
        </b-row>
    </b-form-group>
</template>

<script>
import BtnResponsiveProp from "@components/editor/properties/components/btn-responsive-prop.vue";
import PropertiesComponent from "@components/editor/properties/components/properties-component.vue";
import SidebarGroup from "@components/editor/properties/components/sidebar-group.vue";
import InputColor from "@components/editor/properties/inputs/input-color.vue";
import EInput from "../../../../../vue-components/components/e-input.vue";

// input-padding #hot-reload-debug
export default {
    name: `input-padding`,
    components: {SidebarGroup, EInput, BtnResponsiveProp, InputColor},
    props: {
        value: {},
        title: {type: String, required: true}
    },
    computed: {
        currentPadding: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
